import { useState, useEffect } from 'react';
import { useAuth } from './useAuth';
import { useDashboard } from './useDashboard';
import { fetchJSON, AuthError } from '@/api/client';

export interface SLAMetric {
  metric_name: string;
  compliance_pct: number;
  target_value: number;
  actual_value: number;
  violations: number;
}

export function useSLA() {
  const { token, logout } = useAuth();
  const { refreshKey } = useDashboard();
  const [metrics, setMetrics] = useState<SLAMetric[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!token) return;
    let cancelled = false;
    fetchJSON<{ metrics?: SLAMetric[]; per_sla?: SLAMetric[] }>('/api/dashboard/sla', token)
      .then((d) => { if (!cancelled) { setMetrics(d.metrics || d.per_sla || []); setLoading(false); } })
      .catch((e) => {
        if (e instanceof AuthError) { logout(); return; }
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, [token, refreshKey, logout]);

  return { metrics, loading };
}
